import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {
  AlertComponent,
  FooterComponent,
  ManagerSelectComponent,
  ModalViewComponent,
  NavbarComponent,
  PageNotFoundComponent,
  SearchFormComponent,
  SignaturePadComponent,
  WriteupsListComponent
} from "./components";
import {ClickOutsideDirective, DealerIconDirective, DealerLogoDirective} from "./directives";
import {RouterModule} from "@angular/router";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {
  DealFilterPipe,
  DealSortPipe,
  HowOldPipe,
  OrderByPipe,
  TeamFilterPipe,
  VehicleNamePipe,
  VehicleSortPipe,
  TruncatePipe
} from "./pipes/";
import {FeedbackComponent} from "./components/feedback/feedback.component";
import {ActivityComponent} from './components/activity/activity.component';
import {ActivityEventsComponent} from './components/activity-events/activity-events.component';
import {CDK_DRAG_CONFIG, DragDropModule} from "@angular/cdk/drag-drop";
import {OverlayModule} from "@angular/cdk/overlay";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {DialogCloseButtonComponent} from './components/buttons/dialog-close-button/dialog-close-button.component';
import {MatSidenavModule} from "@angular/material/sidenav";
import {BreadcrumbComponent} from './components/navbar/breadcrumb/breadcrumb.component';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {
  ImportInventoryDialogComponent
} from './components/dialogs/import-inventory-dialog/import-inventory-dialog.component';
import {MatDialogModule} from "@angular/material/dialog";
import {MatListModule} from "@angular/material/list";
import {
  CustomerPrioritiesDialogComponent
} from './components/dialogs/customer-priorities-dialog/customer-priorities-dialog.component';
import { VehicleSoldTableComponent } from './components/reports/vehicle-sold-table/vehicle-sold-table.component';
import { VehicleSoldTableSummaryComponent } from './components/reports/vehicle-sold-table-summary/vehicle-sold-table-summary.component';
import { ReportDaySelectorComponent } from './components/reports/report-day-selector/report-day-selector.component';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatNativeDateModule} from "@angular/material/core";
import {MatInputModule} from "@angular/material/input";
import { PhoneNumberPipe } from "./pipes/phone-number.pipe";
import { TooltipIconComponent } from './components/tooltip-icon/tooltip-icon.component';
import { PillBoxComponent } from './components/pill-box/pill-box.component';
import { PillComponent } from './components/pill/pill.component';
import { ArrayToPillsPipe } from './pipes/array-to-pills.pipe';

const DragConfig = {
  dragStartThreshold: 0,
  pointerDirectionChangeThreshold: 5,
  zIndex: 10000,
};

@NgModule({
  declarations: [
    AlertComponent,
    ClickOutsideDirective,
    DealerIconDirective,
    DealerLogoDirective,
    PageNotFoundComponent,
    ManagerSelectComponent,
    NavbarComponent,
    ModalViewComponent,
    SearchFormComponent,
    WriteupsListComponent,
    DealFilterPipe,
    DealSortPipe,
    VehicleSortPipe,
    HowOldPipe,
    OrderByPipe,
    PhoneNumberPipe,
    TeamFilterPipe,
    VehicleNamePipe,
    TruncatePipe,
    SignaturePadComponent,
    FooterComponent,
    FeedbackComponent,
    ActivityComponent,
    ActivityEventsComponent,
    DialogCloseButtonComponent,
    BreadcrumbComponent,
    ImportInventoryDialogComponent,
    CustomerPrioritiesDialogComponent,
    VehicleSoldTableComponent,
    VehicleSoldTableSummaryComponent,
    ReportDaySelectorComponent,
    TooltipIconComponent,
    PillBoxComponent,
    PillComponent,
    ArrayToPillsPipe
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    OverlayModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatListModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule
  ],
  exports: [
    CommonModule,
    DealerIconDirective,
    DealerLogoDirective,
    AlertComponent,
    OrderByPipe,
    NavbarComponent,
    FooterComponent,
    ModalViewComponent,
    PageNotFoundComponent,
    SearchFormComponent,
    WriteupsListComponent,
    VehicleNamePipe,
    HowOldPipe,
    VehicleSortPipe,
    TruncatePipe,
    SignaturePadComponent,
    ClickOutsideDirective,
    DialogCloseButtonComponent,
    PhoneNumberPipe,
    VehicleSoldTableComponent,
    VehicleSoldTableSummaryComponent,
    ReportDaySelectorComponent,
    TooltipIconComponent,
    PillBoxComponent,
    PillComponent,
    ArrayToPillsPipe,
  ],
  providers: [{provide: CDK_DRAG_CONFIG, useValue: DragConfig}]
})
export class SharedModule {
}
